import { gql } from '@apollo/client';

export const DELETE_RESERVATION_MODE = gql`
  mutation DeleteReservationMode($record: DeleteReservationModeInput!) {
    schedule {
      deleteReservationMode(record: $record) {
        ok
        error {
          message
          code
        }
      }
    }
  }
`;
